import { Component, OnDestroy, OnInit } from '@angular/core';
import { MapServiceService } from '../../../services/Map-service/map-service.service';
import { SideNavService } from '../../../services/sidenav/side-nav.service';



@Component({
  selector: 'app-information',
  templateUrl: './information.component.html',
  styleUrls: ['./information.component.css'],
})
export class InformationComponent implements OnInit, OnDestroy {
  html: any;
  show: any;
  // closeRight =
  //   '<span><strong>Close</strong><p>Clear map selection(s) and close panel</p></span>';
  myClose = {
    showDelay: 500,
    'tooltip-class': 'new-tooltip-class15',
  };
  constructor(
    public sideNavService: SideNavService,
    public mapService: MapServiceService
  ) {
    //
  }

  ngOnInit(): void {
    // this.sideNavService.sideNavState('closed');
    this.sideNavService.infoSideNav('open');

    this.html = this.mapService.accessMapApi.map_data.map_data.information.html;
  }

  closeRightpanel(): void {
    this.sideNavService.clickedInfo(0);
    this.sideNavService.closeRightSideNav();
    this.sideNavService.infoSideNav('closed');
  }
  ngOnDestroy() {
    // this.sideNavService.informationIsLoaded = false;
  }
}
